import { ArrowDownThin } from '@ori-ui/icons';
import { Typography } from '@ori-ui/mui';
import useTestId from '@ori/testid-generator';
import { type FC, useState, useCallback } from 'react';

import { ACCORDION } from './constants';
import { StyledAccordionSummary, StyledMuiAccordion, StyledAccordionDetails } from './styles';
import { type AccordionProps } from './types';

export const Accordion: FC<AccordionProps> = ({ children, header, ...rest }) => {
  const { getTestId } = useTestId();
  const [expanded, setExpanded] = useState<boolean>(false);
  const toggle = useCallback((value: boolean) => () => setExpanded(value), []);

  return (
    <StyledMuiAccordion
      data-testid={getTestId(ACCORDION)}
      expanded={expanded}
      elevation={0}
      onChange={toggle(!expanded)}
      {...rest}
    >
      <StyledAccordionSummary expandIcon={<ArrowDownThin />}>
        <Typography
          textTransform="uppercase"
          fontWeight="bold"
        >
          {header}
        </Typography>
      </StyledAccordionSummary>
      <StyledAccordionDetails>{children}</StyledAccordionDetails>
    </StyledMuiAccordion>
  );
};
